import { render, staticRenderFns } from "./bigshop.vue?vue&type=template&id=f2c0ebec"
import script from "./bigshop.vue?vue&type=script&lang=js"
export * from "./bigshop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports